import React, { useState, useEffect } from "react";
import { Modal, Form, Input, Select, Upload, Button, Image, message, Row, Col, } from "antd";
import ReactQuill from "react-quill";
import "react-quill/dist/quill.snow.css";
import { UploadOutlined } from "@ant-design/icons";
import callApi from "../../constants/API/CallApi";
import { uploadFileToS3 } from "../../helper/uploadImage";
import { ShowToast, Severty } from "../../helper/toast";
import { addContent, getBranches, getClasses, ListClass, getBelts } from "../../constants/API/API";
import useApi from "../../hooks/useApi";

const { Option } = Select;

const allowedImageTypes = ["image/png", "image/jpeg", "image/webp"];
const allowedVideoTypes = [
  "video/mp4",
  "video/quicktime",
  "video/x-m4v",
  "video/webm",
  "video/mov",
];
const allowedDocs = ["application/pdf"];

const ContentAdd = ({ visible, setVisible, refresh }) => {
  const [form] = Form.useForm();
  const [loading, setLoading] = useState(false);
  const [videoLoading, setVideoLoading] = useState(false);
  const [thumbnailLoading, setThumbnailLoading] = useState(false);
  const [description, setDescription] = useState("");
  const [file, setFile] = useState([]);
  const [thumbnail, setThumbnail] = useState([]);
  const [classList, setClassList] = useState([]);
  const [branches, setBranches] = useState([]);
  const [belts, setBelts] = useState([]);
  const [contentType, setContentType] = useState("");
  const [selectedBelt, setSelectedBelt] = useState(null);
  const [selectedBranch, setSelectedBranch] = useState(null);

  useApi({
    callback: getBelts,
    payload: selectedBranch ? { branchId: selectedBranch } : null,
    dependencies: [selectedBranch],
    shouldCallApi: !!selectedBranch,
    onSuccess: ({ data }) => {
      setBelts(data);
    },
  });


  useApi({
    callback: getBranches,
    payload: {},
    dependencies: [],
    shouldCallApi: true,
    onSuccess: ({ data }) => {
      const activeBranches = (data || []).filter((branch) => branch.isActive);
      setBranches(activeBranches);
    },
    onError: (err) => console.log("Error fetching branch list", err),
  });

  useApi({
    callback: getClasses,
    dependencies: [refresh],
    shouldCallApi: true,
    onSuccess: ({ data }) => {
      setClassList(data || []);
    },
  });

  const handleCancel = () => {
    setVisible(false);
    form.resetFields();
    setDescription("");
    setFile([]);
    setThumbnail([]);
  };

  const beforeUpload = (file, type) => {
    const validTypes =
      type === "thumbnail" ? allowedImageTypes : allowedVideoTypes;
    if (!validTypes.includes(file.type)) {
      message.error("Unsupported file type.");
      return Upload.LIST_IGNORE;
    }
    // if (file.size / 1024 / 1024 > 100) {
    //   message.error("File must be smaller than 100MB.");
    //   return Upload.LIST_IGNORE;
    // }
    return true;
  };

  const handleFileUpload = async (info, field) => {
    const { file } = info;
    if (field === "src") {
      setVideoLoading(true);
    } else {
      setThumbnailLoading(true);
    }
    try {
      const data = await uploadFileToS3({
        file,
        bucketName: "invent-co-new",
        dirName: "content",
      });
      const fileData = {
        uid: file.uid,
        name: file.name,
        status: "done",
        url: data.Location,//`${process.env.REACT_APP_AWS_S3_ENDPOINT}/${process.env.REACT_APP_AWS_S3_BUCKET_NAME}/` + data.Key,
        thumbUrl: data.Location,
      };
      if (field === "src") {
        setFile([fileData]);
        form.setFieldsValue({
          src: data.Location,//`${process.env.REACT_APP_AWS_S3_ENDPOINT}/${process.env.REACT_APP_AWS_S3_BUCKET_NAME}/` + data.Key,
        });
      } else {
        setThumbnail([fileData]);
        form.setFieldsValue({ thumbnail: data.Location });
      }
    } catch (error) {
      console.error(error);
      message.error("Upload failed.");
    } finally {
      if (field === "src") {
        setVideoLoading(false);
      } else {
        setThumbnailLoading(false);
      }
    }
  };

  const handleOk = async (values) => {
    setLoading(true);
    const payload = {
      ...values,
      description,
    };
    if (!description?.trim()) {
      return message.error("Enter valid description.");
    } else {
      // payload.description = description?.trimStart();
      const payload = {
        ...values,
        description: description?.trimStart(),
        ...(contentType === "video" && { beltId: selectedBelt }),
      };
    }
    // Replace with actual API call
    callApi({
      callback: addContent,
      payload,
      onSuccess: ({ message }) => {
        ShowToast(message, Severty.SUCCESS);
        form.resetFields();
        setDescription("");
        setFile([]);
        setThumbnail([]);
        setVisible(false);
        refresh();
        setLoading(false);
      },
      onError: (err) => {
        ShowToast(err, Severty.ERROR);
        setLoading(false);
      },
    });
  };

  return (
    <Modal
      open={visible}
      width={800}
      centered
      className="tab_modal"
      title="Add Content"
      okText="Submit"
      onCancel={handleCancel}
      okButtonProps={{
        form: "contentForm",
        htmlType: "submit",
        loading,
        disabled: videoLoading || thumbnailLoading,
      }}
    >
      <Form id="contentForm" form={form} onFinish={handleOk} layout="vertical">
        <Row gutter={12}>
          <Col span={24} md={12}>
            {" "}
            <Form.Item
              name="contentType"
              label="Content Type"
              rules={[{ required: true, message: "Content Type is required!" }]}
            >
              <Select placeholder="Select type"
                onChange={(value) => setContentType(value)} >
                <Option value="info">Informational</Option>
                <Option value="video">Training Video</Option>
              </Select>
            </Form.Item>

          </Col>


          <Col span={24} md={12}>
            <Form.Item
              name="title"
              label="Title"
              normalize={(val) => val?.trimStart()}
              rules={[{ required: true, message: "Title is required!" }]}
            >
              <Input placeholder="Enter title" />
            </Form.Item>
          </Col>

          <Col span={24} sm={24} md={12}>
            <Form.Item
              name="branchId"
              label="Branch"
              rules={[{ required: true, message: "Please select branch!" }]}
            >
              <Select placeholder="Select Branch"
                onChange={(value) => {
                  setSelectedBranch(value);
                  setBelts([]);
                  form.setFieldsValue({ beltId: undefined });
                }}
              >
                {branches?.map((branch) => (
                  <Select.Option key={branch?._id} value={branch?._id}>
                    {branch?.name}
                  </Select.Option>
                ))}
              </Select>
            </Form.Item>
          </Col>

          {contentType === "video" && (
            <Col span={24} md={12}>
              <Form.Item
                name="beltId"
                label="Select Belt"
                rules={[{ required: true, message: "Please select a belt!" }]}
              >
                <Select
                  placeholder="Select Belt"
                  onChange={(value) => setSelectedBelt(value)}
                >
                  {belts?.map((belt) => (
                    <Option key={belt._id} value={belt._id}>
                      {belt.name}
                    </Option>
                  ))}
                </Select>
              </Form.Item>
            </Col>
          )}

          <Col span={24} md={12}>
            <Form.Item name="class" label="Class (Optional)">
              <Select mode="multiple" placeholder="Select class" allowClear>
                {classList.map((cls) => (
                  <Option key={cls._id} value={cls._id}>
                    {cls.name}
                  </Option>
                ))}
              </Select>
            </Form.Item>
          </Col>

          <Col span={24} md={12}>
            {" "}
            <Form.Item
              name="src"
              rules={[{ required: true, message: "Video is required!" }]}
              label="Upload Video"
            >
              <Upload
                accept="video/*"
                listType="video"
                maxCount={1}
                beforeUpload={(file) => beforeUpload(file, "src")}
                customRequest={(info) => handleFileUpload(info, "src")}
                fileList={file}
                onRemove={() => {
                  setFile([]);
                  form.setFieldsValue({ src: "" });
                }}
              >
                {file.length < 1 && (
                  <Button icon={<UploadOutlined />} loading={videoLoading}>Upload</Button>
                )}
              </Upload>
            </Form.Item>
          </Col>

          <Col span={24} md={12}>
            <Form.Item name="thumbnail" label="Upload Thumbnail (optional)">
              <Upload
                accept="image/*"
                listType="picture"
                maxCount={1}
                beforeUpload={(file) => beforeUpload(file, "thumbnail")}
                customRequest={(info) => handleFileUpload(info, "thumbnail")}
                fileList={thumbnail}
                onRemove={() => {
                  setThumbnail([]);
                  form.setFieldsValue({ thumbnail: "" });
                }}
              >
                {thumbnail.length < 1 && (
                  <Button icon={<UploadOutlined />} loading={thumbnailLoading}>Upload Thumbnail</Button>
                )}
              </Upload>
              {thumbnail.length > 0 && (
                <div className="mt-2">
                  <Image width={100} src={thumbnail[0].url} />
                </div>
              )}
            </Form.Item>
          </Col>

          <Col span={24}>
            <Form.Item label="Description">
              <ReactQuill
                theme="snow"
                value={description}
                onChange={setDescription}
              />
            </Form.Item>
          </Col>
        </Row>
      </Form>
    </Modal>
  );
};

export default ContentAdd;
